import { render, staticRenderFns } from "./UserManagementDetailsScreen.vue?vue&type=template&id=11ffb82d&scoped=true&"
import script from "./UserManagementDetailsScreen.vue?vue&type=script&lang=js&"
export * from "./UserManagementDetailsScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11ffb82d",
  null
  
)

export default component.exports